const SET_CONFIG_HASH = 'SET_CONFIG_HASH';

export default {
  SET_CONFIG_HASH
};
